import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// components
import VisualizationWidget from "widgets/components/VisualizationWidget"

// selectors
import {
    selectWidgetDataSources,
    selectWidgetDescription,
    selectWidgetFilters,
    selectWidgetKey,
    selectWidgetQuorumDataType,
} from "app/static/frontend/widgets/selectors/selectors"

import {
    selectColors,
    selectCumulative,
    selectInterval,
    selectLabels,
    selectVisSubtype,
    selectVisWidgetCanLoad,
    // bar, map
    selectFrequencyTupleField,
} from "app/static/frontend/widgets/selectors/visWidgetSelectors"

const mapStateToProps = createStructuredSelector({
    canLoad: selectVisWidgetCanLoad,
    dataSources: selectWidgetDataSources,
    description: selectWidgetDescription,
    filters: selectWidgetFilters,
    widgetKey: selectWidgetKey,

    colors: selectColors,
    cumulative: selectCumulative,
    interval: selectInterval,
    labels: selectLabels,
    visSubtype: selectVisSubtype,

    // bar, map
    frequencyTupleField: selectFrequencyTupleField,

    qdt: selectWidgetQuorumDataType,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizationWidget)
